var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50mm",
    height: "50mm",
    viewBox: "0 0 49.226015 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "path1",
    cx: 25,
    cy: 25,
    r: 24
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#ffffff",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none",
      paintOrder: "stroke fill markers"
    },
    d: "M 69.650391,3.8085938 C 68.521692,4.4607075 67.826385,5.6652107 67.826172,6.96875 v 25.326172 c 0.0013,2.808818 3.041685,4.563843 5.474609,3.160156 L 95.232422,22.792969 c 2.433171,-1.405104 2.433171,-4.917162 0,-6.322266 L 73.300781,3.8085938 c -1.129433,-0.6520845 -2.520957,-0.6520845 -3.65039,0 z",
    id: "path6",
    transform: "matrix(0.82926388,0,0,0.82926388,-40.278656,8.7966135)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.0c1a8d08d41889e653da7cbe034c5e2f.svg";
export { ForwardRef as ReactComponent };